import { CreateElement } from '@src/vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Mixins } from 'vue-mixin-decorator'
import ClickOutside from 'vue-click-outside'

import { Element } from '@src/mixins/element/element'
import { Icon } from '@src/elements/icon/icon'
import { H6 } from '@src/elements/typography/typography'
import { Divider } from '@src/elements/divider/divider'

import { stopPropagation } from '@src/util/functions'

import './modal.sass'
import { noop } from '@src/util/noop'

@Component({
  directives: {
    ClickOutside
  }
})
export class Modal extends Mixins<Element>(Element) {

  @Prop({ required: false })
  title: string

  @Prop({ required: false, default: '' })
  cssClass: string

  @Prop({ required: true })
  show: boolean

  @Prop({ required: false, default: 'scrollable' })
  overflow: 'scrollable' | 'hidden' | 'visible'

  @Prop({ required: false })
  closeCallback: () => void

  @Prop({ required: false, default: false })
  disableClickOutside: boolean

  @Prop({ required: false })
  extraStyles: object

  @Prop({ required: false, default: noop })
  scroll: () => void

  private clickedInside = false

  created () {
    if (this.show) window.addEventListener('mousedown', this.onClick)
  }

  @Watch('show')
  onShowChanged () {
    if (this.show) {
      window.addEventListener('mousedown', this.onClick)
    } else window.removeEventListener('mousedown', this.onClick)
  }

  beforeDestroy () {
    window.removeEventListener('mousedown', this.onClick)
  }

  onClick (e) {
    if (!e.path) return
    this.clickedInside = !!e.path.filter((el) => {
      return el && el.classList && el.classList.contains('modal-container')
    }).length
  }

  render (h: CreateElement) {

    return (
      this.renderModal(h)
    )
  }

  protected renderModal (h: CreateElement) {
    return (this.show ?
      <div class={`modal ${this.cssClass}`} id='modalComponent'>
        <div class='modal-container' v-click-outside={this.clickOutside}>
          <div class='modal-header'>
            <H6>{this.title || this.$slots.customTitle}</H6>
            <div onClick={this.close} class='close-btn'><Icon name='util/close-circled' /></div>
            {this.$slots.header}
            {this.$slots.header ? <Divider /> : null}
          </div>
          <div class={`modal-body ${this.overflow}`}
               style={this.extraStyles} id='modal-body'
               onScroll={this.scroll}>
            {this.$slots.default}
          </div>
          <div class='modal-footer'>
            {this.$slots.footer ? <Divider /> : null}
            {this.$slots.footer}
          </div>
        </div>
      </div> : '')
  }

  protected close (e) {
    stopPropagation(e)
    this.closeCallback()
  }

  protected clickOutside () {
    if (!this.disableClickOutside && !this.clickedInside) {
      this.closeCallback()
    }
  }
}
